<div class="score-card" [style.--score-color]="'var(' + colorVar() + ')'">
  <div class="score-card-header">
    <span class="label">{{ label() }}</span>
    <span class="value" [class.suspended]="isRatingSuspended()"
      ><span class="value-number">{{ isRatingSuspended() ? '?' : value() }}</span
      ><span class="max-number">/{{ max() }}</span></span
    >
  </div>
  <div class="track">
    <div class="fill" [style.width.%]="fillPercent()"></div>
  </div>
</div>
